import React, { useState } from 'react';
import { Checkbox, FormControl, FormControlLabel, Grid, Typography } from '@mui/material';

export const StepAdicionalesMinuta = ({ fullFormData, handleChangeFullFormData, allowedWrite }) => {
    const [minutas] = useState([
        { id: 'minuta_DNI', descripcion: 'DNI' },
        { id: 'minuta_nombreApellido', descripcion: 'Nombre y Apellido' },
        { id: 'minuta_nroAfiliado', descripcion: 'Nro Afiliado' },
        { id: 'minuta_nroOC', descripcion: 'Nro OC' },
        { id: 'minuta_nroRemito', descripcion: 'Nro Remito' }
    ]);

    const handleCheck = (e) => {
        const { id, checked } = e.target;
        handleChangeFullFormData(id, checked);
    };

    return (
        <FormControl fullWidth component="fieldset">
            <Typography variant="h6" component="legend" gutterBottom>
                Adicionales impresos en Observaciones
            </Typography>
            <Grid container justifyContent="space-between">
                {minutas.map((minuta) => (
                    <Grid key={minuta.id} size="grow">
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={!!fullFormData[minuta.id]}
                                    size="small"
                                    id={minuta.id}
                                    onChange={handleCheck}
                                    disabled={!allowedWrite}
                                />
                            }
                            labelPlacement='start'
                            label={minuta.descripcion}
                        />
                    </Grid>
                ))}
            </Grid>
        </FormControl>
    );
};
